module.exports = __webpack_public_path__ + "img/9791187206880.71032a46.jpg";